export default {
  default: () => import("/srv/sites/cryptoxchange/cryptoxchange-nuxt/layouts/default.vue").then(m => m.default || m)
}